import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Icon from '../../../Common/Icon/index';
import Badge from '@material-ui/core/Badge';
import React from 'react';

import styles from './styles';

const ItemTypeChip = ({ itemType, count }) => {
  const chip = (<Chip
    style={count === 0 ? styles.chip : {}}
    key={itemType.id}
    label={itemType.name}
    avatar={itemType.icon ?
      <Avatar size={32}><Icon name={itemType.icon} size={30}/></Avatar> : null}
  />);

  return count > 0 ? (<Badge
    badgeContent={count}
    color="primary"
    key={itemType.id}
    style={styles.chip}
  >{chip}</Badge>) : chip;
};

export default ItemTypeChip;



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfilesGrid/ItemTypeChip.js